import { useState, useContext, useEffect } from 'react'
import Input from '../../components/Input'
import Layout from "../../components/layout"
import { HeaderWrapper, ContentWrapper } from './style'
import { AuthContext } from '../../context/auth';
import ItemPreviewDrawer from '../../components/Drawers/ItemPreviewDrawer';
import Pagination from '../../components/pagination';
import { getThermofisherProductsApi, updateProductMetadataApi } from '../../api'
import { useDebounce } from 'use-debounce'
import InventoryModal from '../../components/modals/InventoryModal';

const Index = () => {
  const { setOpenItemPreviewModal, openItemPreviewModal, setIsLoading, isLoading, setNotification, setOpenAddProduct} = useContext(AuthContext)
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [products, setProducts] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState('')
  const [debouncedSearch] = useDebounce(search, 300);
  const [openInventoryModal, setOpenInventoryModal] = useState(false)

  const fetchProduct = () => {
    setIsLoading(true)
    getThermofisherProductsApi(10, currentPage * 10, search).then(res => {
      if (res && res.data) {
        setProducts(res?.data)
        setIsLoading(false)
      }
      setIsLoading(false)
    }).catch(err => {
      console.error(err)
      setIsLoading(false)
    })
  }

  const onUpdate = (link) => {
    setIsLoading(true)
    updateProductMetadataApi(selectedProduct?.id, {
      key: 'thermofisher_link',
      value: link
    }).then(res => {
      if (res?.data) {
        fetchProduct()
        setOpenInventoryModal(false)
        setSelectedProduct(null)
        setNotification({
          message: "Thermofisher Link Updated Successfully",
          type: "green"
        })
      }
    }).catch(err => {
      setNotification({
        message: "Something went wrong",
        type: "red"
      })
    })
    setIsLoading(false)
  }

  useEffect(() => {
      fetchProduct()
  }, [debouncedSearch, currentPage])

  return (
    <>
      <Layout>
        <HeaderWrapper>
          <div className="header-title"><span className='sub-title'>Thermofisher</span> {products.count > 0 && `(${products.count})`}</div>
          <div className="header-search-container">
            <Input type="text" search style={{ height: '40px', paddingLeft: '30px' }} placeholder={'Search'} value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
        </HeaderWrapper>
        <ContentWrapper>
          {products && products?.products?.length > 0 ?
            <>
              <table className={"mainTable"}>
                <thead>
                  <tr>
                    <th>Cat ID# </th>
                    <th>Target</th>
                    <th>Product Name</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Link</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {products?.products?.map((business) => {
                    return (
                      <tr
                        key={business?.id}
                      >
                        <td>
                          {business?.material ? business?.mid_code + " " + business?.material : "-"}
                        </td>
                        <td>
                          {business?.mid_code.search("SA") >= 0 ? business?.species_reactivity ? business?.species_reactivity : "-" : business?.subtitle ? business?.subtitle : "-"}
                        </td>
                        <td style={{ width: '400px' }}>
                          {business?.title ? business?.title : "-"}
                        </td>
                        <td><span style={{ fontWeight: 600 }}>${business?.variants[0]?.prices[0] ? (business?.variants[0]?.prices[0]?.amount / 100)?.toFixed(2) : "-"}</span></td>
                        <td><span style={{ fontWeight: 600, color: business?.variants[0]?.inventory_quantity ? "#1E1E1E" : "#DC1E00" }}>{business?.variants[0]?.inventory_quantity ? business?.variants[0]?.inventory_quantity : "Out of Stock"}</span></td>
                        <td><span style={{ fontWeight: 600, color: business?.metadata?.thermofisher_link ? "#2ECC71" : "#DC1E00" }}>{business?.metadata?.thermofisher_link ? 'Available' : "Not Available"}</span></td>
                        <td style={{ cursor: "pointer" }}>
                          <span style={{ display: 'flex', gap: '30px', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <button style={{ fontSize: '16px', color: '#6c6a73' }} onClick={() => {
                              setOpenItemPreviewModal(true)
                              setSelectedProduct(business)                 
                            }}><i class="fal fa-eye"></i></button>
                            <button style={{ fontSize: '16px', color: '#6c6a73' }} onClick={() => {
                              setSelectedProduct(business)
                              setOpenInventoryModal(true)
                            }}><i class="fal fa-pencil"></i></button>
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
             {products?.count / products.limit > 1 && <Pagination total={products?.count / products.limit} setCurrentPage={setCurrentPage} currentPage={currentPage} selectedProduct={selectedProduct} /> }
            </>
            :
            <div className='no-orders'>
              <span className='icon'>
                <i class="fal fa-boxes"></i>
              </span>
              <p>No Products Yet.</p>
            </div>
          }
        </ContentWrapper>
      </Layout>
      {openInventoryModal && <InventoryModal  setOpenInventoryModal={setOpenInventoryModal} isLoading={isLoading} selectedProduct={selectedProduct} onUpdate={onUpdate} type={'thermo'} />}
      {openItemPreviewModal && <ItemPreviewDrawer setOpenItemPreviewModal={setOpenItemPreviewModal} setOpenAddProduct={setOpenInventoryModal} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} />}
    </>
  )
}

export default Index